export default __webpack_public_path__ + "static/media/failed.4b16b6d2.svg";